import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../..";

import { maintemanceSchedulesAnalytics, MaintenanceCountQuery } from "../../../services/analytics/maintenance";
import { AlertResponse } from "../../../config/types";

interface CountClassifierMetric {
  data?: Record<string, number>;
  loading?:boolean
}

interface MaintenanceSchedulesMetricsState {
  classifier: CountClassifierMetric | null;
  total?: number;
  alerts: AlertResponse & {
    loading:boolean
  };
  total_upcoming_count:number
  total_overdue_count:number
  timeSeries: unknown | null;
}

const initialState: MaintenanceSchedulesMetricsState = {
  classifier: {loading:true},
  timeSeries: null,
  alerts:{
    upcoming:[],
    overdue:[],
    loading:true
  },
  total_overdue_count:0,
  total_upcoming_count:0
};

export const maintenanceSchedulesMetrics = createSlice({
  name: "MaintenanceSchedulesMetrics",
  initialState,
  reducers: {
    updateClassifier: (state, action: PayloadAction<CountClassifierMetric>) => {
      state.classifier = action.payload;
    },
    updateTimeSeries: (state, action: PayloadAction<unknown>) => {
      state.timeSeries = action.payload;
    },
    updateTotalCount: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },

    updateAlertCounter: (state, action: PayloadAction<{total_overdue_count:number,total_upcoming_count:number}>) => {
      state.total_overdue_count = action.payload.total_overdue_count;
      state.total_upcoming_count=action.payload.total_upcoming_count
    },
    
    updateAlert: (state, action: PayloadAction<AlertResponse>) => {
      state.alerts = {...action.payload,loading:false}
    },
    startFetch: (state) => {
        if (state.classifier) {
            state.classifier.loading = true;
          } else {
            state.classifier = { loading: true };
          }

      },
    

  },
});

export const { updateClassifier, updateTotalCount, updateTimeSeries,startFetch, updateAlert,updateAlertCounter } =
maintenanceSchedulesMetrics.actions;

export const updateMaintenanceScheduleCountClassifier =
  (query?: MaintenanceCountQuery): AppThunk =>
  async (dispatch) => {
    try {
      const result = await maintemanceSchedulesAnalytics.getMaintenanceCount(query ?? {});
  
      dispatch(
        updateClassifier({
          data: result.data,
          loading: false,
        })
      );
    } catch (err) {}
  };

export const updateMaintenanceScheduleCountTotal = (): AppThunk => async (dispatch) => {
  try {
    const result = await maintemanceSchedulesAnalytics.getMaintenanceCount({});
    if (result?.data) {
      dispatch(updateTotalCount(result.totalRecords ?? 0));
    }
  } catch (err) {}
};

export const updateAlertMetric=(): AppThunk => async (dispatch) => {
  try {
    const result = await maintemanceSchedulesAnalytics.getMaintenanceAlert()
    if (result?.data) {
      dispatch(updateAlert(result.data));
    }
  } catch (err) {}
};
export const updateAlertCount=(): AppThunk => async (dispatch) => {
  try {
    const result = await maintemanceSchedulesAnalytics.getMaintenanceAlert()
    if (result?.data) {
      dispatch(updateAlertCounter({
        total_overdue_count: result.extra?.total_overdue_count ?? 0,
        total_upcoming_count: result.extra?.total_upcoming_count ?? 0})
      );
    }
  } catch (err) {}
};
export default maintenanceSchedulesMetrics.reducer;
